import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FaChevronLeft } from 'react-icons/fa';
import UserGuideContent from './UserGuideContent';

const UserGuideDrawer = ({ isOpen, sidebarWidth, onClose }) => {
	const bodyRef = useRef(null);
	const savedScrollRef = useRef(0);

	// Save scroll position when closing, restore when opening.
	useEffect(() => {
		if (!bodyRef.current) return;
		if (isOpen) {
			bodyRef.current.scrollTop = savedScrollRef.current;
		} else {
			savedScrollRef.current = bodyRef.current.scrollTop;
		}
	}, [isOpen]);

	return (
		<div
			className={`user-guide-drawer${isOpen ? '' : ' user-guide-drawer--closed'}`}
			style={{
				left: sidebarWidth,
				width: `calc(75vw - ${sidebarWidth})`,
			}}
			aria-hidden={!isOpen}
		>
			<div className="user-guide-drawer__header">
				<span>User Guide</span>
				<button
					className="user-guide-drawer__close-btn"
					onClick={onClose}
					aria-label="Close user guide"
				>
					<FaChevronLeft size={13} />
					Close
				</button>
			</div>
			<div className="user-guide-drawer__body" ref={bodyRef}>
				<UserGuideContent />
			</div>
		</div>
	);
};

UserGuideDrawer.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	sidebarWidth: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default UserGuideDrawer;
